var App = App || {};

App.Header = (function ($) {
    'use strict';

    function MegaMenu() {

        let mmActive = false;
        const mmSpeed = 300;

        const lvl1Container = $("header .header-primary > nav > ul.level-1-list");
        const lvl1Trigger = lvl1Container.children("li").children("a.level-1-item, button.level-1-item");

        const lvl2List = $("header .site-header-lvl-2 ul.level-2-list");
        const lvl2Trigger = lvl2List.children("li").children("a.lvl-2-item, button.lvl-2-item");
        const lvl3Items = lvl2List.find(".mega-menu").find("a");

        let mmActiveItems = [];
        let mmActiveItem = 0;

        lvl1Trigger.on("mouseenter", function () {
            Lvl2Open($(this));
        }).on("focus", function () {
            Lvl2Open($(this));
        }).on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    $('#' + $(this).data("target")).children("li").first().children("a, button").trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    break;
            }
        });

        lvl2List.on("mouseleave", function () {
            mmActive = false;
            MegaMenuClose(lvl2Trigger, mmSpeed);
        }).on("keydown", function (e) {
            if (e.key === "Tab") {
                mmActive = false;
                MegaMenuClose($(this).children("li").children("a, button"), 1);
            }
        });

        lvl2Trigger.on("mouseenter", function () {
            MegaMenuOpen($(this), mmActive ? 1 : mmSpeed);
            mmActive = true;
        }).on("focus", function () {
            MegaMenuOpen($(this), 1);
            mmActive = true;
        }).on("blur", function () {
            if (mmActive === false) {
                MegaMenuClose($(this), 1);
            }
        }).on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    var lvl2Id = $(this).parents("ul.level-2-list").attr("id");
                    $(".level-1-item[data-target=" + lvl2Id + "]").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItems = [];
                    mmActiveItem = 0;
                    $(this).siblings(".mega-menu").find("a:visible").each(function () { mmActiveItems.push(this); });
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    MegaMenuClose($(this), mmSpeed);
                    var lvl2Id = $(this).parents("ul.level-2-list").attr("id");
                    $(".level-1-item[data-target=" + lvl2Id + "]").trigger("focus");
                    break;
            }
        });

        lvl3Items.on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem < mmActiveItems.length - 1 ? mmActiveItem + 1 : 0;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem > 0 ? mmActiveItem - 1 : mmActiveItems.length - 1;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    $(this).parents(".mega-menu").parent("li").children("a, button").trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    var MenuButton = $(this).parents(".mega-menu").siblings("a, button");
                    MegaMenuClose(MenuButton, mmSpeed);
                    var lvl2Id = $(this).parents("ul.level-2-list").attr("id");
                    $(".level-1-item[data-target=" + lvl2Id + "]").trigger("focus");
                    break;
            }
        });
    }

    function Lvl2Open(trigger) {
        var targetId = '#' + trigger.data("target");
        $("ul.level-1-list").addClass("open");
        $(".level-1-item[aria-expanded='true']").attr("aria-expanded", "false").removeClass("open");
        $("ul.level-2-list.active").removeClass("active");
        trigger.attr("aria-expanded", "true").addClass("open");
        $(targetId).addClass("active");
    }

    function MegaMenuOpen(trigger, speed) {
        trigger.attr("aria-expanded", "true").addClass("open").siblings(".mega-menu").stop().slideDown(speed);
        MegaMenuClose(trigger.parents("li").siblings("li").children("a, button"), speed);
        $(".level-2-list.active").addClass("open");
    }

    function MegaMenuClose(trigger, speed) {
        $(".level-2-list.active").removeClass("open");
        trigger.attr("aria-expanded", "false").removeClass("open").siblings(".mega-menu").stop().slideUp(speed);
    }

    return {
        MegaMenu: MegaMenu
    };

})(jQuery);